import React from 'react';

import { Box } from '@chakra-ui/react';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { isMobileView } from 'constants/isMobileView';

import { TextHeader2 } from 'uiToolkitV1/Typography';

export const PageHeading = ({ title }) => {
  if (typeof title === 'string')
    return (
      <TextHeader2
        px={(isMobileView() ? 3 : 0) + (!checkNewNavEnabled() ? 4 : 7)}
        py={!checkNewNavEnabled() ? 2 : 4}
        bold
      >
        {title}
      </TextHeader2>
    );

  return (
    <Box px={(isMobileView() ? 3 : 0) + (!checkNewNavEnabled() ? 4 : 7)} py={!checkNewNavEnabled() ? 2 : 4}>
      {title}
    </Box>
  );
};
